module.exports = __webpack_public_path__ + "img/av-icon-black.d9f1b53c.svg";